import { _ } from '@ngx-translate/core';
import { SoilComposition } from '@app/core/enums/soil-composition.enum';
import { NonLeakNoiseSource } from '@app/core/enums/non-leak-noise-source.enum';

export const soilCompositionLocalize: Record<SoilComposition, string> = {
  [SoilComposition.Unknown]: _(`@@shared-soil-composition__unknown`),
  [SoilComposition.Porous]: _(`@@shared-soil-composition__porous`),
  [SoilComposition.NonPorous]: _(`@@shared-soil-composition__non-porous`),
};

export const nonLeakNoiseSourceLocalize: Record<NonLeakNoiseSource, string> = {
  [NonLeakNoiseSource.EnvNoise]: _(`@@shared-non-leak-source__ambient-noise`),
  [NonLeakNoiseSource.Fountain]: _(`@@shared-non-leak-source__fountain`),
  [NonLeakNoiseSource.Irrigation]: _(`@@shared-non-leak-source__irrigation`),
  [NonLeakNoiseSource.Pump]: _(`@@shared-non-leak-source__pump`),
  [NonLeakNoiseSource.Prv]: _(`@@shared-non-leak-source__prv`),
  [NonLeakNoiseSource.WaterUsage]: _(`@@shared-non-leak-source__water-usage`),
  [NonLeakNoiseSource.Other]: _(`@@shared-other__label`),
  [NonLeakNoiseSource.Unknown]: _(`@@shared-non-leak-source__unknown`),
};
